import * as go from 'gojs';

export const toggleDiagramGrid = (diagram: go.Diagram, gridVisible: boolean) => {
  diagram.grid.visible = gridVisible;
};
